import { supabase } from '../supabaseClient';

const BUCKET = 'client-documents';

export const PortalDocumentsService = {
  async listDocuments(clientId) {
    if (!clientId) return { data: [], error: new Error('Missing client id') };
    try {
      const { data, error } = await supabase
        .from('submission_documents')
        .select(`
          id,
          title,
          document_type,
          status,
          storage_path,
          requested_at,
          submitted_at,
          reviewed_at,
          reviewer,
          metadata
        `)
        .eq('client_id', clientId)
        .order('requested_at', { ascending: true });
      if (error) throw error;
      return { data: data || [], error: null };
    } catch (error) {
      console.error('[PortalDocumentsService] listDocuments failed', error);
      return { data: [], error };
    }
  },

  async uploadDocument({ clientId, file, documentType, title, metadata = {} }) {
    if (!clientId || !file) {
      return { data: null, error: new Error('Missing client id or file') };
    }

    const path = `client/${clientId}/${Date.now()}_${file.name}`;

    try {
      const uploadResult = await supabase.storage
        .from(BUCKET)
        .upload(path, file, {
          cacheControl: '3600',
          upsert: true,
          contentType: file.type || 'application/octet-stream'
        });

      if (uploadResult.error) throw uploadResult.error;

      const { data, error } = await supabase
        .from('submission_documents')
        .insert([{
          client_id: clientId,
          document_type: documentType || 'general',
          title: title || file.name,
          status: 'submitted',
          storage_path: path,
          submitted_at: new Date().toISOString(),
          metadata
        }])
        .select()
        .single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('[PortalDocumentsService] uploadDocument failed', error);
      return { data: null, error };
    }
  },

  async deleteDocument(documentId) {
    if (!documentId) return { error: new Error('Missing document id') };
    try {
      const { data, error } = await supabase
        .from('submission_documents')
        .delete()
        .eq('id', documentId)
        .select()
        .single();
      if (error) throw error;

      if (data?.storage_path) {
        await supabase.storage.from(BUCKET).remove([data.storage_path]);
      }

      return { data, error: null };
    } catch (error) {
      console.error('[PortalDocumentsService] deleteDocument failed', error);
      return { data: null, error };
    }
  },

  async getDocumentUrl(path) {
    if (!path) return { data: null, error: new Error('Missing path') };
    try {
      const { data, error } = await supabase.storage
        .from(BUCKET)
        .createSignedUrl(path, 3600); // 1 hour expiry

      if (error) throw error;
      return { data: data?.signedUrl, error: null };
    } catch (error) {
      console.error('[PortalDocumentsService] getDocumentUrl failed', error);
      return { data: null, error };
    }
  }
};
